/**
 * Auswahl in der Aufgabenliste (Aufgabenverwaltung 2.0, 27.10.2026): Map aufgabe_id -> Kurzangaben. Die Auswahl hängt an stabilen IDs und bleibt
 * über Such-/Filterwechsel und Seiten erhalten (auch für Aufgaben, die gerade nicht sichtbar sind). Eine Auswahl ändert NIE eine Aufgabe.
 */

const kurz = (a) => ({ id: a.id, klient_id: a.klient_id || null, titel: a.titel || '', status: a.status || null, eltern_aufgabe_id: a.eltern_aufgabe_id || null });

export function umschalten(auswahl, aufgabe) {
  const n = new Map(auswahl);
  if (n.has(aufgabe.id)) n.delete(aufgabe.id);
  else n.set(aufgabe.id, kurz(aufgabe));
  return n;
}

/** Alle gefilterten (Server-Treffer) hinzu – oder, wenn schon alle gewählt sind, genau diese wieder ab. */
export function alleGefilterten(auswahl, treffer) {
  const liste = Array.isArray(treffer) ? treffer : [];
  const n = new Map(auswahl);
  if (liste.length && liste.every(t => n.has(t.id))) liste.forEach(t => n.delete(t.id));
  else liste.forEach(t => n.set(t.id, kurz(t)));
  return n;
}

export function alleGefiltertenGewaehlt(auswahl, treffer) {
  const liste = Array.isArray(treffer) ? treffer : [];
  return liste.length > 0 && liste.every(t => auswahl.has(t.id));
}

/** Setzt die Auswahl auf genau diese Aufgaben (z. B. aus einer ZEO-Antwort). */
export function nur(aufgaben) {
  return new Map((aufgaben || []).filter(a => a && a.id).map(a => [a.id, kurz(a)]));
}

/** Klient der Auswahl, wenn alle Aufgaben zu genau einem Klienten gehören – sonst null (klientenübergreifend). */
export function einKlient(auswahl) {
  const k = new Set([...auswahl.values()].map(a => a.klient_id));
  return k.size === 1 && !k.has(null) ? [...k][0] : null;
}

/** Zusammenführen: mindestens zwei Aufgaben desselben Klienten. */
export function zusammenfuehrbar(auswahl) {
  return auswahl.size >= 2 && Boolean(einKlient(auswahl));
}

// Statusgruppen für Aufgabenlisten (ZEO-Chat, 27.10.2026). „geloescht“ umfasst alle Systemzustände geschlossener/ersetzter Aufgaben und nicht mehr
// auffindbare Aufgaben – diese erscheinen nie in „Alle“ oder „Offen“, nur im ausdrücklich gewählten Filter „Gelöscht“.
export const GELOESCHT_STATUS = ['geloescht', 'dupliziert', 'zusammengefuehrt', 'zusammengefasst', 'archiviert', 'rauschen', 'verworfen', 'storniert', 'nicht_vorhanden'];
export const VORSCHLAG_STATUS = ['aufgabenvorschlag_frist_pruefen', 'zuordnung_pruefen'];

export function statusGruppe(status) {
  if (GELOESCHT_STATUS.includes(status)) return 'geloescht';
  if (status === 'erledigt' || status === 'abgeschlossen') return 'erledigt';
  if (VORSCHLAG_STATUS.includes(status)) return 'vorschlag';
  return 'offen';
}

const falte = (t) => String(t || '').toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');

/** filter: alle (ohne gelöschte) | offen | vorschlag | erledigt | geloescht; q: Stichwörter (alle müssen in Titel/Beschreibung/Klient vorkommen). */
export function filterAufgaben(liste, filter = 'alle', q = '') {
  const terme = falte(q).split(/\s+/).filter(Boolean);
  return (liste || []).filter((a) => {
    const g = statusGruppe(a.status);
    if (filter === 'alle' ? g === 'geloescht' : g !== filter) return false;
    const text = falte([a.titel, a.beschreibung, a.klient_name, a.betreuter_name].join(' '));
    return terme.every((t) => text.includes(t));
  });
}
